import { UseFormSetError } from 'react-hook-form';
import { ToastProps } from '@hopskipdrive/react-components';

import { ValidationErrors } from '../../api/services/Riders';

type FormProps = {
  setError: UseFormSetError<RiderFormType>;
  setFullNameError: (error: string) => void;
  validationErrors: ValidationErrors;
  addToast: (toast: ToastProps) => void;
};

export const setFormErrorsForRiderProfile = ({ setError, setFullNameError, validationErrors, addToast }: FormProps) => {
  for (const property in validationErrors) {
    switch (property) {
      case 'contactError':
        handleContactErrors(setError, setFullNameError, validationErrors.contactError);
        break;
      case 'email':
        setError('email', { message: validationErrors.email });
        break;
      case 'profilePhoto':
        setError('photosAttributes.0.attachment', { message: validationErrors.profilePhoto });
        break;
      case 'sharedBillingRider':
        for (const field in validationErrors.sharedBillingRider) {
          const sharedBillingField = `sharedBillingRider.${field}` as keyof RiderFormType;

          setError(sharedBillingField, { message: validationErrors.sharedBillingRider[field] });
        }
        break;
      default:
        addToast({
          severity: 'error',
          message:
            typeof validationErrors[property] === 'string'
              ? validationErrors[property]
              : `Incorrect input for ${property}`,
        });
        break;
    }
  }
};

function handleContactErrors(setError, setFullNameError, error) {
  if (error.fullName) {
    setFullNameError(error.fullName);
    setError('firstName', { message: error.fullName });
    setError('lastName', { message: error.fullName });
  }
  if (error.phoneNumber) {
    setError('mobilePhoneNumber', { message: error.phoneNumber });
  }
  if (error.dateOfBirth) {
    setError('dateOfBirth', { message: error.dateOfBirth });
  }
}
